import { motion } from "framer-motion";
import { fadeInUp } from "@/lib/animations";

interface PhotoBreakProps {
  src: string;
  alt: string;
  className?: string;
}

const PhotoBreak = ({ src, alt, className = "" }: PhotoBreakProps) => {
  return (
    <motion.div
      className={`relative w-full h-[40vh] md:h-[50vh] overflow-hidden ${className}`}
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background pointer-events-none" />
    </motion.div>
  );
};

export default PhotoBreak;
